import React from 'react'

import AddSizeForm from '../../modules/Size/components/AddSizeForm'
export default function AddSizePage() {
  return (
    <AddSizeForm/>  )
}
